var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { InformationIcon, Title, Subline, FlexWrapper, MarginAutoWrapper, IconBackground } from './style';
import { Button } from '../../forms';
import { FaExclamationCircle, FaQuestionCircle, FaEnvelope, FaCheckCircle } from 'react-icons/fa';
var defaultIcons = {
    information: FaQuestionCircle,
    warning: FaExclamationCircle,
    email: FaEnvelope,
    success: FaCheckCircle
};
var renderExtraActionButtons = function (props) {
    return props.actions.map(function (actionBtn, key) {
        return (_createElement(Button, __assign({}, props.actionProps, { key: key, type: "button", color: actionBtn.color, style: __assign({}, actionBtn.styles), onClick: actionBtn.method }), actionBtn.text));
    });
};
var renderIcon = function (props) {
    var Icon = (_jsx(InformationIcon, { iconBackground: props.iconBackground, small: props.small ? 1 : 0, as: props.icon ? props.icon : defaultIcons[props.type] }));
    return props.iconBackground ? (_jsx(IconBackground, __assign({ small: props.small, iconBackground: props.iconBackground }, { children: Icon }))) : (Icon);
};
var FancyInformationMessage = function (props) {
    return (_jsx(FlexWrapper, __assign({ small: props.small, style: __assign({ minHeight: 'unset', marginTop: '0' }, props.style), className: props.className }, { children: _jsxs(MarginAutoWrapper, { children: [props.icon !== 'none' && renderIcon(props), _jsx(Title, __assign({}, props.titleProps, { small: props.small, "data-test-id": props['data-test-id'] }, { children: props.title })), props.subline && (_jsx(Subline, __assign({}, props.sublineProps, { small: props.small }, { children: props.subline }))), props.children, props.action && (_jsx(Button, __assign({}, props.actionProps, { type: "button", color: "primary", style: { minWidth: '9rem' }, onClick: props.action.method }, { children: props.action.text }))), props.actions && renderExtraActionButtons(props)] }) })));
};
FancyInformationMessage.defaultProps = {
    type: 'warning',
    iconBackground: false
};
export default FancyInformationMessage;
//# sourceMappingURL=index.js.map